import React from 'react';
import SAPB1Reports from '../components/SAPB1Reports/SAPB1Reports';

const SAPB1ReportsPage: React.FC = () => {
  return <SAPB1Reports />;
};

export default SAPB1ReportsPage;
